<template>
  <div class="answer-container" :class="[{ 'answer-matrix': hasMatrixQu }]">
    <div class="answer-wrapper">
      <Form ref="answerValidate" :model="config" @submit.native.prevent>
        <div class="an-head">
          <slot name="top" v-if="!isGroupTitle">
            <!--<div class="qu-type">
              <answer-rect></answer-rect>
              <answer-type>
              {{config.displayElementDesc}}
              </answer-type>
            </div>-->
          </slot>
          <slot name="head">
            <!-- flex-h-center -->
            <p class="title desc-style" :class="[{'is-info-qu': config.elementType === 'InfoBox'}]" v-if="isShowTitle">
              <span v-if="showQuNum" class="qu-num">{{config.quCode}}.</span>
              <span v-if="config.answerConfig.requireInd === '1' && config.elementType !== 'InfoBox'" class="require">*</span>
              <!-- <span ref="titleMain" class="title-main" v-html="config.displayTitle"></span> -->
              <span class="qu-title" v-html="config.displayTitle"></span>
              <span v-if="showQuType" class="qu-type">
                <span v-if="['TitleBox', 'TimeBox', 'CascadeBox', 'RadioBox'].includes(config.elementType) && config.mediaQuType">(<span v-html="getSubDesc(config.mediaQuType)"></span>)</span>
                <span v-else>(<span v-html="config.displayElementDesc"></span>)</span>
              </span>
              <slot name="sub-title"></slot>
              <span class="media-wrapper">
                <template v-if="config.imgUrl">
                  <ipsos-av style="display: flex; justify-content: center" v-if="isAv(config.imgUrl)" :src="config.imgUrl"></ipsos-av>
                  <ipsos-image v-else :imgUrl="config.imgUrl" :preview="config.id || config.displayTitle"></ipsos-image>
                </template>
              </span>
            </p>
          </slot>
        </div>
        <div v-if="config.elementType !== 'InfoBox'" class="an-body">
          <slot name="body"></slot>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import configList from '@/components/editor/config'
export default {
  name: 'AnswerRender',
  props: ['config', 'cvtLang'],
  data () {
    return {
      configList
    }
  },
  components: {},
  watch: {
    'config.value': {
      deep: true,
      handler (val) {
        sessionStorage.setItem('descChangeStatus', 0)
        this.$refs.answerValidate.validate()
      }
    },
    'config.descList': {
      deep: true,
      handler () {
        // console.log('config.descList----')
        sessionStorage.setItem('descChangeStatus', 0)
        if (this.config.elementType === 'RateGroupBox' && sessionStorage.getItem('descPropValid')) {
          this.$refs.answerValidate.validateField(sessionStorage.getItem('descPropValid'))
        } else {
          this.$refs.answerValidate.validate()
        }
      }
    },
    'config.useTagInput': {
      deep: true,
      handler () {
        // 满意度题-标签规则验证
        sessionStorage.setItem('descChangeStatus', 0)
        this.$refs.answerValidate.validate()
      }
    },
    'answerStyleConfig.lang': {
      deep: true,
      handler() {
        // 用于外观预览时修改通用设置信息实时显示
        this.$refs.answerValidate.validate()
      }
    },
    lang: {
      handler() {
        this.$refs.answerValidate.validate()
      }
    }
  },
  computed: {
    ...mapState({
      answerStyleConfig: ({Question}) => Question.answerStyleConfig,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang,
      lang: ({Question}) => Question.lang,
      langMap: ({Question}) => Question.langMap
    }),
    /**
     * 显示题号
     */
    showQuNum () {
      return this.answerStyleConfig.common.showQuNumInd === '1'
    },
    /**
     * 显示题型
     */
    showQuType () {
      return this.answerStyleConfig.common.showQuestionType === '1'
    },
    isGroupTitle () {
      const config = this.config
      return /^RadioBoxGroup|CheckBoxGroup$/.test(config.elementType) && config.descIndex > 0
    },
    isShowTitle () {
      // if (this.config.page === 1 && this.answerStyleConfig.common.showQuNumInd === '1') {
      //   return false
      // }
      return true // !this.surveyStyle.surveyHideTitle
    },
    quItem () {
      const { mediaQuType, elementType } = this.config
      if (mediaQuType) {
        return this.configList.find(item => item.mediaQuType === mediaQuType)
      }
      return this.configList.find(item => item.elementType === elementType)
    },
    elementDesc () {
      return this.quItem.elementDesc
    },
    hasMatrixQu () {
      let flg = false
      const {descIndex, descList} = this.config
      if (descList.length && descIndex > -1) {
        flg = descIndex < descList.length - 1
      }

      return flg
    }
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    getSubDesc (mediaQuType) {
      let str
      switch(mediaQuType) {
        // 个人信息题
        case 'infocollection':
          str = this.cvtLang('InfoCollectBox', this.surveyInfoLang.InfoCollectBox)
          break;
        case 'xingming':
          str = this.cvtLang('XingMingBox', this.surveyInfoLang.XingMingBox)
          break;
        case 'phone1':
          str = this.cvtLang('ShouJiBox', this.surveyInfoLang.ShouJiBox)
          break;
        case 'email':
          str = this.cvtLang('YouXiangBox', this.surveyInfoLang.YouXiangBox)
          break;
        case 'idCard':
          str = this.cvtLang('ShenFenBox', this.surveyInfoLang.ShenFenBox)
          break;
        // 生日题
        case 'birthday':
          str = this.cvtLang('ShengRiBox', this.surveyInfoLang.ShengRiBox)
          break;
        // 行业题
        case 'industry':
          str = this.cvtLang('IndustryBox', this.surveyInfoLang.IndustryBox)
          break;
        // 专业题
        case 'major':
          str = this.cvtLang('MajorBox', this.surveyInfoLang.MajorBox)
          break;
        // 职业题
        case 'occupation':
          str = this.cvtLang('OccupationBox', this.surveyInfoLang.OccupationBox)
          break;
        // 学历题
        case 'education':
          str = this.cvtLang('EducationBox', this.surveyInfoLang.EducationBox)
          break;
        // 年龄题
        case 'ageGroup':
          str = this.cvtLang('AgeGroupBox', this.surveyInfoLang.AgeGroupBox)
          break;
        // 性别题
        case 'sex':
          str = this.cvtLang('SexBox', this.surveyInfoLang.SexBox)
          break;
        // 投票题
        case 'vote':
          str = this.cvtLang('VoteBox', this.surveyInfoLang.VoteBox)
          break;
      }
      return str
    }
  },
  created () {},
  mounted () {
    // setTimeout(() => {
    //   if (this.answerStyleConfig.common.showQuNumInd === '1' && this.$refs.titleMain) {
    //     for (let i = 0; i < this.$refs.titleMain.children.length; i++) {
    //       if (this.$refs.titleMain.children[i].localName === 'p') {
    //         this.$refs.titleMain.children[i].innerHTML = `${'<span class="qu-num">' + this.config.quNum + '.</span>'}${this.$refs.titleMain.children[i].innerHTML}`
    //         return
    //       }
    //     }
    //   }
    // }, 0)
  }
}
</script>
<style lang="scss" scoped>
  .wyb {
    margin-bottom: 0px !important;
  }
  .answer-container {
    margin-bottom: 40px;
    background-color: #fff;
    padding: 20px 40px;
    .an-head {
      .title {
        padding-bottom: 40px;
        border-bottom: 1px solid #f1f1f1;
        .require {
          font-size: 36px;
          color: #FF645A;
        }
        .qu-num, .qu-title {
          font-size: 32px;
          font-weight: 500;
          color: #000;
          margin-right: 10px;
        }
        .qu-type {
          color: #bbb;
          font-size: 28px;
        }
        .option-title {
          font-size: 28px;
        }
        .media-wrapper {
          display: flex;
          justify-content: center;
        }
      }
      .is-info-qu {
        border-bottom: none;
      }
    }
    .an-body {
      // padding-top: 30px;
    }
    &.answer-matrix {
      margin-bottom: -20px;
      >>> .ivu-form-item {
        margin-bottom: 5px;
      }
      >>> .ivu-form-item-error-tip {
        position: relative;
      }
      .an-head {
        border-bottom: none !important;
      }
      .an-body {
        display: none;
      }
    }
  }
  .answer-pc {
    .answer-container {
      margin-bottom: 30px;
      border: 1px solid #F1F1F1;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.0240385);
      padding: 0px;
      .an-head {
        // margin-bottom: 30px;
        border-bottom: 1px solid #f1f1f1;
        .title {
          padding: 0 30px;
          padding-bottom: 20px;
          border-bottom: none;
          .require {
            font-size: 18px;
          }
          .qu-num, .qu-title {
            font-size: 18px;
            margin-right: 5px;
            display: contents;
          }
          .qu-type {
            font-size: 14px;
          }
          .media-wrapper {
            padding: 0px 30px 0px 30px;
            display: flex;
            justify-content: center;
            >>> .av-wrap {
              width: 100%;
              .video-js {
                width: 100% !important;
                height: 3.33rem !important;
              }
            }
          }
        }
      }
      .an-body {
        padding: 20px 40px 10px 80px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerRender.vue